import React                        from 'react';
import { Link }                     from "react-router-dom";

import * as FixedRoute              from 'shared/types/FixedRoute';
import Alert                        from 'utils/Alert';
import * as MenuItem                from 'components/MenuItem';

import getApiPromise                from 'utils/getApiPromise';
import tectransit                   from 'utils/TecTransit';

interface Props {
}
export default class RunCuttingMenuItem extends React.Component<Props> {

    private alert                  : Alert = new Alert();

    public state : {
        runCuttingConfig : FixedRoute.RunCuttingConfig,
        requestStartedMs   : number
    } = {
        runCuttingConfig : {
            daily_best_duration_hours       : 8,
            daily_long_duration_hours       : 10,
            daily_max_long_duration_prcntage: 0.2,
            daily_max_duration_hours        : 13,
            daily_max_driving_hours         : 10,
            daily_max_spread_hours          : 13,
            long_break_every_secs           : 4*3600,
            long_break_duration_secs        : 1800,
            short_break_every_hours         : 2,
            short_break_duration_hours      : (1/6),
            dsoff_for_best_runs             : 1,
            dsoff_for_long_runs             : 2,
            dsoff_min_for_best_runs_prcntage: 0.8,
            min_rest_period_hours           : 10,
            max_parttime_weekhours          : 34,
            max_parttime_runs_percentage    : 0.1,
            extra_board_min_weekhours       : 40,
            timeout_ms                      : 120000,
            max_roster_item_duration_secs   : 11*3600,
            best_hours_per_week             : 40,
            duration_excess_mult            : 2,
            min_advance_report_secs         : (15*60)
        },
        requestStartedMs : -1
    };

    render() {
        return MenuItem.withMenuItem(`Run Cutting`,( alert ) => {
            this.alert = alert;
            return (
                <div className="wrapper">
                    <table width="80%">
                        <tr>
                            <td colSpan={2}>
                                <p>
                                This is a driver time planning tool allowing <strong>{tectransit.agency.name}</strong> dispatchers to cut
                                the total demand for driver time&nbsp;
                                {tectransit.user.roles.includes("Manager")?<>(defined by <Link to="/Manager/Config/FixedRoutes">Fixed Routes
                                Schedule</Link>)</>:''}. into the minimal necessary number of "runs" compliant with the following "run structure".
                                The drivers bid on each run and every business day each run gets assigned to one of the available buses.
                                </p>
                                <strong>Run Structure</strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                if possible, daily runs will be cut to
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    value   = {this.state.runCuttingConfig.daily_best_duration_hours}
                                    min     = {4}
                                    max     = {this.state.runCuttingConfig.daily_long_duration_hours-1}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_best_duration_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Daily runs can also be cut to
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    value   = {this.state.runCuttingConfig.daily_long_duration_hours}
                                    min     = {this.state.runCuttingConfig.daily_best_duration_hours+1}
                                    max     = {this.state.runCuttingConfig.daily_max_duration_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_long_duration_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                The percentage of <b>{this.state.runCuttingConfig.daily_long_duration_hours}</b> hour days should not exceed
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    max     = {100}
                                    min     = {0}
                                    value   = {100*this.state.runCuttingConfig.daily_max_long_duration_prcntage}
                                    onChange= {(e) => {
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_max_long_duration_prcntage : (Number(e.target.value)/100)
                                            }
                                        })
                                    }}
                                />
                                %
                            </td>
                        </tr>
                        <tr>
                            <td>
                                The absolute maximum of daily run duration is
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {this.state.runCuttingConfig.daily_long_duration_hours}
                                    max     = {15}
                                    value   = {this.state.runCuttingConfig.daily_max_duration_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_max_duration_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Max number of driving hours per day
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {2}
                                    max     = {this.state.runCuttingConfig.daily_max_duration_hours-1}
                                    value   = {this.state.runCuttingConfig.daily_max_driving_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_max_driving_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Max spread of workday
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {this.state.runCuttingConfig.daily_long_duration_hours}
                                    max     = {this.state.runCuttingConfig.daily_max_duration_hours+2}
                                    value   = {this.state.runCuttingConfig.daily_max_spread_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                daily_max_spread_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                        <tr>
                            <td>
                                Give short breaks every
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {0}
                                    max     = {Math.round(this.state.runCuttingConfig.long_break_every_secs/3600)-1}
                                    value   = {this.state.runCuttingConfig.short_break_every_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                short_break_every_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Each short break should be at least (<b>0</b> means no short breaks)
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {0}
                                    max     = {60}
                                    value   = {Math.round(this.state.runCuttingConfig.short_break_duration_hours*60)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                short_break_duration_hours : (Number(e.target.value)/60)
                                            }
                                        })
                                    }}
                                />
                                minutes
                            </td>
                        </tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                        <tr>
                            <td>
                                Consequitive weekly days off for <b>{this.state.runCuttingConfig.daily_best_duration_hours}</b> hour long daily schedule
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {1}
                                    max     = {3}
                                    value   = {this.state.runCuttingConfig.dsoff_for_best_runs}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                dsoff_for_best_runs : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                days
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Consequitive weekly days off for <b>{this.state.runCuttingConfig.daily_long_duration_hours}</b> hour long daily schedule
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {1}
                                    max     = {4}
                                    value   = {this.state.runCuttingConfig.dsoff_for_long_runs}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                dsoff_for_long_runs : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                days
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Minimal percentage of assignments having <b>{this.state.runCuttingConfig.dsoff_for_best_runs}</b> consequitive days off
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    max     = {100}
                                    min     = {0}
                                    value   = {100*this.state.runCuttingConfig.dsoff_min_for_best_runs_prcntage}
                                    onChange= {(e) => {
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                dsoff_min_for_best_runs_prcntage : (Number(e.target.value)/100)
                                            }
                                        })
                                    }}
                                />
                                %
                            </td>
                        </tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                        <tr>
                            <td>
                                Minimum rest period per day
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {7}
                                    max     = {16}
                                    value   = {this.state.runCuttingConfig.min_rest_period_hours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                min_rest_period_hours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Most hours per week in part-time runs
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {12}
                                    max     = {36}
                                    value   = {this.state.runCuttingConfig.max_parttime_weekhours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                max_parttime_weekhours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Max percentage of part time runs in a week
                            </td>
                            <td>
                            <input
                                    type    = "number"
                                    max     = {100}
                                    min     = {0}
                                    value   = {100*this.state.runCuttingConfig.max_parttime_runs_percentage}
                                    onChange= {(e) => {
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                max_parttime_runs_percentage : (Number(e.target.value)/100)
                                            }
                                        })
                                    }}
                                />
                                %
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Extra board min weekhours
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {12}
                                    max     = {60}
                                    value   = {this.state.runCuttingConfig.extra_board_min_weekhours}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                extra_board_min_weekhours : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                        <tr>
                            <td>
                                Give lunch breaks every
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {2}
                                    max     = {this.state.runCuttingConfig.daily_max_spread_hours}
                                    value   = {Math.round(this.state.runCuttingConfig.long_break_every_secs/3600)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                long_break_every_secs : (Number(e.target.value)*3600)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Each lunch break should be at least (<b>0</b> means no lunch breaks)
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {0}
                                    max     = {300}
                                    value   = {Math.round(this.state.runCuttingConfig.long_break_duration_secs/60)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                long_break_duration_secs : (Number(e.target.value)*60)
                                            }
                                        })
                                    }}
                                />
                                minutes
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Max roster item duration hours
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {2}
                                    max     = {14}
                                    value   = {Math.round(this.state.runCuttingConfig.max_roster_item_duration_secs/3600)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                max_roster_item_duration_secs : (Number(e.target.value)*3600)
                                            }
                                        })
                                    }}
                                />
                                hours
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Wait for the results for
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {1}
                                    max     = {10}
                                    value   = {this.state.runCuttingConfig.timeout_ms/(1000*60)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                timeout_ms : (Number(e.target.value)*1000*60)
                                            }
                                        })
                                    }}
                                />
                                mins
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Best number of hours a driver works in a week
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {10}
                                    max     = {60}
                                    value   = {this.state.runCuttingConfig.best_hours_per_week}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                best_hours_per_week : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                How much worse it is to exceed the best number of hours than to subceed it
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {0}
                                    max     = {10}
                                    value   = {this.state.runCuttingConfig.duration_excess_mult}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                duration_excess_mult : Number(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Min number of minutes to show up for the workrun before the start of revenue
                            </td>
                            <td>
                                <input
                                    type    = "number"
                                    min     = {0}
                                    max     = {60}
                                    value   = {Math.round(this.state.runCuttingConfig.min_advance_report_secs/60)}
                                    onChange= {(e)=>{
                                        this.setState({
                                            runCuttingConfig : {
                                                ...this.state.runCuttingConfig,
                                                min_advance_report_mins : (60*Number(e.target.value))
                                            }
                                        })
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <br/>
                                <button type="button" className="btn-theme btn-small" onClick={(e) => {
                                    if( this.state.requestStartedMs>0 ) {
                                        this.alert.set(`The request started ${Math.round((Date.now()-this.state.requestStartedMs)/1000)}s ago`,5000);
                                        return;
                                    }
                                    this.setState({
                                        requestStartedMs : Date.now()
                                    });
                                    getApiPromise(`/api/dispatcher/fixedRoute/cutRuns`,'POST',this.state.runCuttingConfig,{},this.state.runCuttingConfig.timeout_ms*2)
                                        .then((res) => {
                                            if( res.err )
                                                throw Error(res.err);
                                            if( typeof res.url !== 'string' )
                                                throw Error(`Url not found in response`);
                                            const w = window.open(res.url,'run_cutting');
                                            if( w )
                                                w.focus();
                                            else
                                                throw Error(`Cannot open the run cutting page, please allow popups for this site`);
                                        })
                                        .catch( err => {
                                            alert.set(`Cannot cut runs (${err.message})`,5000);
                                        })
                                        .finally( () => {
                                            this.setState({
                                                requestStartedMs : -1
                                            });
                                        });
                                }}>
                                    Cut Runs
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            );
        });
    }
}
